export enum MessageRole {
    SYSTEM = "SYSTEM",
    DEVELOPER = "DEVELOPER",
    USER = "USER",
    ASSISTANT = "ASSISTANT",
    FUNCTION = "FUNCTION",
    TOOL = "TOOL",
    CHATBOT = "CHATBOX",
    MODEL = "MODEL",
}
